import { Link, Text } from '@atoms/index';
import { disclaimerData } from '@components/Consents/Disclaimer/helper';
import texts from '@components/Consents/en.json';
import { brandName } from '@helpers/constants';

const Disclaimer = () => {
    const renderDisclaimerContent = () => (
        <>
            <p>
                {texts.disclaimerContent.part1}
            </p>
            <p className="pt-8">
                {texts.disclaimerContent.part2}
                <Link
                    href={process.env.NEXT_PUBLIC_APP_URL}
                    children={process.env.NEXT_PUBLIC_APP_URL}
                    target="_blank"
                    className="font-semibold text-primary-500 underline hover:text-primary-800 visited:text-primary-400"
                />{' '}
                <span dangerouslySetInnerHTML={{ __html: texts.disclaimerContent.part3 }}/>
            </p>
            <p className="pt-8">
                {texts.disclaimerContent.part4}
                <span className="p4-semibold">AI Growth Private Limited</span> {texts.disclaimerContent.part5}{' '}
                <span className="p4-semibold">Texterity Private Limited</span> {texts.disclaimerContent.part6}
                <span className="p4-semibold">“{brandName}”</span>{texts.disclaimerContent.part7}
            </p>
            <p className="pt-8">
                {brandName} {texts.disclaimerContent.part8}
            </p>
        </>
    );

    const renderDisclaimerList = () => (
        <ul className="pl-8 mt-4 marker:p4-medium list-roman md:pl-10">
            {Object.keys(disclaimerData).map((item, index) => (
                <li key={index} className="mt-6">
                    {typeof disclaimerData[item] === 'string' ? (
                        disclaimerData[item]
                    ) : (
                        <>
                            {disclaimerData[item][0]}
                            <ul className="px-5 mt-4 list-alpha marker:p4-medium md:pl-10">
                                {disclaimerData[item].slice(1).map((data, subIndex) => (
                                    <li key={subIndex} className="mt-6">
                                        {data}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </li>
            ))}
        </ul>
    );

    return (
        <div className="mx-auto px-4 md:px-10 lg:px-20 xl:px-26 bg-basicWhite w-full xl:w-10/12">
            <div className="py-8 md:py-10">
                <Text
                    content={texts?.DisclaimersHeading}
                    className="h4-semibold md:h3-semibold text-primary-500 text-center"
                    htmlTag="h1"
                />
            </div>
            <div className="w-full pb-16 md:text-justify">
                <div className="flex flex-wrap overflow-hidden text-base lg:-mx-3 xl:-mx-2">
                    <Text content={renderDisclaimerContent()} />
                    {renderDisclaimerList()}
                </div>
            </div>
        </div>
    );
};

export default Disclaimer;